import React, { useState,useEffect } from 'react';
import {
  Edit,
  TabbedForm,
  Toolbar,
  SaveButton,
  FormTab,
  AutocompleteInput,
  required,
  useTranslate
} from 'react-admin';
import { useAgreementText } from './hooks';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // import the styles
import { ApiResource } from '../../lib/api';
var userAgreementSaved =  '';
var privacyAgreementSaved = '';
const Title = ({ record }: any) => {
  userAgreementSaved=record.agreementUserText;
  privacyAgreementSaved=record.agreementPrivacyText;
  const translate = useTranslate();
  const title = translate('resources.agreements.name', 2);
  return <span>{title}</span>;
};
const AgreementsEdit: React.FC = (props: any) => {
  const [rerenderHack,setRerenderHack] = useState('');
  useEffect(() => {
    const timer = setInterval(() => {
      setRerenderHack(userAgreementSaved)
      if(userAgreementSaved!=''){
        clearTimeout(timer)
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const translate = useTranslate();
  const {
    agreementUserText,
    setAgreementUserText,
    agreementPrivacyText,
    setAgreementPrivacyText
  } = useAgreementText();

  const onEditorStateChangeAgreementUser = (value:any) => {
    userAgreementSaved = value;
    setAgreementUserText(value)
  };
  const onEditorStateChangeAgreementPrivacy = (value:any) => {
    privacyAgreementSaved = value;
    setAgreementPrivacyText(value)
  };
  return (
    <Edit {...props}
    title={<Title/>}
    undoable={true}
    >

      <TabbedForm
        redirect={false}
        toolbar={<OnlySaveToolbar agreementUserText={agreementUserText} agreementPrivacyText={agreementPrivacyText}/>}
      >
        <FormTab label={translate('pages.agreements.tabs.user')}>
          <ReactQuill
            className="editor-wrapper"
            theme="snow"
            value={userAgreementSaved}
            onChange={onEditorStateChangeAgreementUser}
          />
        </FormTab>
        <FormTab label={translate('pages.agreements.tabs.privacy')}>
          <ReactQuill
            className="editor-wrapper"
            theme="snow"
            value = {privacyAgreementSaved}
            onChange={onEditorStateChangeAgreementPrivacy}
          />
        </FormTab>
      </TabbedForm>
    </Edit>
  );
};

const OnlySaveToolbar: React.FC<any> = (props) => {
  var onSave = () => {
    localStorage.setItem('userAgreementSaved', props.agreementUserText);
    localStorage.setItem('privacyAgreementSaved', props.agreementPrivacyText);
  }
  const {
    agreementUserUpdatedAt,
    agreementUserUpdatedBy
  } = props.record
  return (
    <Toolbar
      {...props}
    >
      <SaveButton onClick={onSave}/>
      <div className='right-align gray-color'> Последние изменение: {agreementUserUpdatedAt}, {agreementUserUpdatedBy}</div>
    </Toolbar>
  );
};
export default AgreementsEdit;